/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Audit_Details_Pattern_Edited_NamedInputs */



/**
* | output |
* | --- |
* | "The custom pattern \"{name}\" was edited. Its rules decide what is redacted or blocked, so this changes how requests are handled across the organisation." |
*
* @param {Audit_Details_Pattern_Edited_NamedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_pattern_edited_named = /** @type {((inputs: Audit_Details_Pattern_Edited_NamedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Pattern_Edited_NamedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Das eigene Muster "${i?.name}" wurde bearbeitet. Seine Regeln bestimmen, was maskiert oder blockiert wird - die Änderung wirkt sich auf alle Anfragen der Organisation aus.`)
	return /** @type {LocalizedString} */ (`The custom pattern "${i?.name}" was edited. Its rules decide what is redacted or blocked, so this changes how requests are handled across the organisation.`)
});